import { Box, Flex, createStyles } from '@mantine/core';

export function IconBitcoin({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * (37 / 24);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <svg x="11.5" y="5" width="14" height="14" viewBox="0 0 14 14.0001">
        <path
          d="M13.789 8.69347C12.8541 12.4435 9.05591 14.7257 5.30544 13.7906C1.55651 12.8556 -0.725712 9.05726 0.209663 5.30744C1.14416 1.55697 4.94232 -0.725463 8.69169 0.209474C12.4419 1.14441 14.7239 4.94322 13.789 8.69347Z"
          fill="#F7931A"
        />
        <path
          d="M10.0854 6.00287C10.2248 5.07143 9.51561 4.57071 8.54589 4.23668L8.86045 2.97493L8.09242 2.78352L7.78617 4.01202C7.58426 3.96171 7.37689 3.91424 7.17082 3.86721L7.47926 2.63062L6.71167 2.43921L6.39689 3.70052C6.22976 3.66246 6.0657 3.62484 5.90645 3.58524L5.90732 3.58131L4.84814 3.31684L4.64382 4.13715C4.64382 4.13715 5.21367 4.26774 5.20164 4.27584C5.5127 4.35349 5.56892 4.55934 5.55951 4.72252L5.2012 6.15993C5.22264 6.1654 5.25042 6.17327 5.28104 6.18552C5.25545 6.17918 5.22811 6.17218 5.19989 6.1654L4.69764 8.17899C4.65957 8.27349 4.56311 8.41524 4.34567 8.36143C4.35332 8.37259 3.78742 8.22209 3.78742 8.22209L3.40614 9.10124L4.40561 9.3504C4.59154 9.39699 4.77376 9.44577 4.95314 9.49171L4.63529 10.7679L5.40245 10.9593L5.71723 9.69668C5.92679 9.75356 6.13023 9.80606 6.32929 9.85549L6.01561 11.1122L6.78364 11.3036L7.10148 10.0298C8.41114 10.2777 9.39595 10.1777 9.81048 8.99318C10.1445 8.03943 9.79386 7.48927 9.10479 7.13052C9.60661 7.01481 9.98461 6.68471 10.0854 6.00287ZM8.33064 8.46359C8.09329 9.41734 6.48745 8.90174 5.96682 8.77246L6.38857 7.08174C6.9092 7.21168 8.5787 7.46893 8.33064 8.46359ZM8.5682 5.98909C8.35164 6.85665 7.01507 6.41587 6.58151 6.30781L6.96389 4.77437C7.39745 4.88243 8.79373 5.08412 8.5682 5.98909Z"
          fill="white"
        />
      </svg>
    </svg>
  );
}

export function IconEthereum({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * (37 / 24);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <svg x="14.175" y="5" width="8.65" height="14" viewBox="0 0 9.62988 15.5911">
        <path
          d="M4.81352 1.62877e-05L4.7083 0.35532V10.6645L4.81352 10.7688L9.62693 7.94021L4.81352 1.62877e-05Z"
          fill="#343434"
        />
        <path d="M4.81353 0L0 7.94019L4.81353 10.7688V5.76504V0Z" fill="#8C8C8C" />
        <path
          d="M4.81349 11.6748L4.75419 11.7467V15.419L4.81349 15.5911L9.62985 8.84766L4.81349 11.6748Z"
          fill="#3C3C3B"
        />
        <path d="M4.81353 15.5911V11.6748L0 8.84766L4.81353 15.5911Z" fill="#8C8C8C" />
        <path
          d="M4.81353 10.7689L9.62693 7.94024L4.81353 5.76509V10.7689Z"
          fill="#141414"
        />
        <path d="M0 7.94024L4.81353 10.7689V5.76509L0 7.94024Z" fill="#393939" />
      </svg>
    </svg>
  );
}

export function IconCryptoMore({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * (37 / 24);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <text
        x="18.75"
        y="12"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Inter, sans-serif"
        fontSize="10"
        fontWeight="600"
        fill="#C1C2C5"
      >
        +100
      </text>
    </svg>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    gap: theme.other.spacing._8,
    maxWidth: 130,
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
}));

export function CryptoTypeIconMultiple() {
  const { classes } = useStyles();
  return (
    <Flex className={classes.container}>
      <Box className={classes.iconBox}>
        <IconBitcoin />
      </Box>
      <Box className={classes.iconBox}>
        <IconEthereum />
      </Box>
      <Box className={classes.iconBox}>
        <IconCryptoMore />
      </Box>
    </Flex>
  );
}
